import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { updateStep } from "../../redux/actions/meetingActions/MeetingAction";
import { useSelector, useDispatch } from "react-redux";
const steps = ["Create Meeting", "Add Attendee(s)", "Add Agenda(s)"];

const CommonStepper = React.memo((props) => {
  const dispatch = useDispatch();
  const handleStepUpdate = (page) => {
    dispatch(updateStep(page - 1));
  };
  const meetingData = useSelector((state) => state.meeting);

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={props.step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={label}>
            {props?.fromEditMeeting ? (
              <StepLabel
                onClick={() => handleStepUpdate(index + 1)}
                className={
                  meetingData?.step === index + 3 || meetingData?.step === index
                    ? "active"
                    : ""
                }
              >
                {label}
              </StepLabel>
            ) : (
              <StepLabel>{label}</StepLabel>
            )}
          </Step>
        ))}
      </Stepper>
    </Box>
  );
});

export default CommonStepper;
